import { mangaList, type Manga } from "@/mocks/manga";
import { categories, type MangaCategory } from "@/mocks/categories";

export { mangaList };

export function getCategory(id: string): MangaCategory {
  return (
    categories.find((c) => c.id === id) || {
      id,
      name: id,
      tagline: "",
      desc: "",
      icon: "ri-book-2-line",
      cover: "",
      color: "primary",
      count: 0,
    }
  );
}

export function formatNum(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

export function sortByPopularity(list: Manga[]): Manga[] {
  return [...list].sort((a, b) => b.popularity - a.popularity);
}

export function sortByRating(list: Manga[]): Manga[] {
  return [...list].sort((a, b) => b.rating - a.rating);
}

export function getById(id: string): Manga | undefined {
  return mangaList.find((m) => m.id === id);
}

export function relatedManga(id: string, limit = 4): Manga[] {
  const current = getById(id);
  if (!current) return mangaList.slice(0, limit);
  const sameCat = mangaList
    .filter((m) => m.category === current.category && m.id !== id)
    .sort((a, b) => b.popularity - a.popularity);
  const others = mangaList
    .filter((m) => m.category !== current.category && m.id !== id)
    .sort((a, b) => b.popularity - a.popularity);
  return [...sameCat, ...others].slice(0, limit);
}